import React, { createRef, RefObject, useEffect, useState } from 'react';
import mobileScreenOff from '../images/mobile_screen_off_low_resolution.png';
import mobileRebalancear from '../images/mobile_rebalancear_low_resolution.png';
import Auth0RegisterUserButton from '../features/authentication/auth0-register-user';
import { useTitle } from '../app/utils';

const HomePage: React.FC = () => {

  function useIsVisible(ref: RefObject<HTMLElement>) {
    useTitle("Rebalancear - App para Rebalancear seu Portfólio (Carteira) de Investimentos");
    const [isIntersecting, setIntersecting] = useState(false);

    useEffect(() => {
      const observer = new IntersectionObserver(([entry]) => {
        setIntersecting(entry.isIntersecting)
      });
      if (ref.current) {
        observer.observe(ref.current);
      }
      return () => {
        observer.disconnect();
      };
    }, [ref]);

    return isIntersecting;
  }

  const refMainMessage = createRef<HTMLLabelElement>();
  const isVisibleMainMessage = useIsVisible(refMainMessage);

  return (
    <div className="flex flex-col justify-start h-full w-full text-white overflow-y-auto">
      <div className='flex flex-col-reverse lg:flex-row w-full h-full p-5 lg:p-24 items-center justify-end lg:justify-start'>

        <div className='relative flex w-4/5 lg:w-1/3 h-fit lg:h-full pr-12 lg:pr-0 mt-2 lg:mt-20 justify-center'>
          <img src={mobileScreenOff} alt='MobileScreenOff' className={`absolute h-56 lg:h-fit top-0 m-auto transition-opacity delay-[7s] duration-[2s] ease-out ${isVisibleMainMessage ? "opacity-100" : "opacity-0"}`} />
          <img src={mobileRebalancear} alt='MobileRebalancear' className={`absolute z-10 h-56 lg:h-fit top-0 m-auto transition-opacity delay-[8s] duration-[2s] ease-out ${isVisibleMainMessage ? "opacity-100" : "opacity-0"}`} />
        </div>

        <div className='flex flex-col lg:w-2/3 h-fit lg:h-full lg:p-10 w-fit text-base lg:text-3xl font-light'>

          <div className='uppercase font-semibold'>
            <label>APP PARA REBALANCEAMENTO DE PORTFÓLIO</label>
          </div>

          <div className={`self-center h-1 border-b my-1 lg:mt-5 lg:mb-0 border-blue-300/40 [mask-image:linear-gradient(to_right,transparent_0,black_70px,black_calc(100%-70px),transparent_100%)] transition-all delay-[5s] duration-500 ease-out ${isVisibleMainMessage ? "w-full" : "w-0"}`}></div>

          <div className={`flex flex-col w-fit py-2 lg:py-10 text-sm lg:text-2xl delay-[8s] duration-[1s] ease-out ${isVisibleMainMessage ? "lg:px-8" : "px-0"}`}>
            <label id='MainMessage' ref={refMainMessage} className={`transition-opacity delay-1000 duration-[2s] ease-out ${isVisibleMainMessage ? "opacity-100" : "opacity-0"}`}>
              Rebalancear seu Portfólio deveria ser algo racional
            </label>

            <label ref={refMainMessage} className={`mt-3 lg:mt-10 transition-opacity delay-[2s] duration-[2s] ease-out ${isVisibleMainMessage ? "opacity-100" : "opacity-0"}`}>
              mas o emocional pode atrapalhar nessa hora.
            </label>

            <label ref={refMainMessage} className={`mt-3 lg:mt-10 transition-opacity delay-[3s] duration-[2s] ease-out ${isVisibleMainMessage ? "opacity-100" : "opacity-0"}`}>
              Vender um ativo com o preço subindo...
            </label>

            <label ref={refMainMessage} className={`mt-3 lg:mt-10 transition-opacity delay-[4s] duration-[2s] ease-out ${isVisibleMainMessage ? "opacity-100" : "opacity-0"}`}>
              Ou comprar quando está caindo...
            </label>

            <label ref={refMainMessage} className={`mt-3 lg:mt-10 transition-opacity delay-[5s] duration-[2s] ease-out ${isVisibleMainMessage ? "opacity-100" : "opacity-0"}`}>
              Pode ser difícil às vezes.
            </label>
          </div>

          <div className={`self-center h-1 border-b my-1 border-blue-300/40 [mask-image:linear-gradient(to_right,transparent_0,black_70px,black_calc(100%-70px),transparent_100%)] transition-all delay-[5s] duration-500 ease-out ${isVisibleMainMessage ? "w-full" : "w-0"}`}></div>

          <label ref={refMainMessage} className={`mt-2 lg:mt-5 lg:pr-60 transition-opacity delay-[6s] duration-[2s] ease-out ${isVisibleMainMessage ? "opacity-100" : "opacity-0"}`}>
            Nesses momentos, o app Rebalancear te ajuda a agir com a razão.
          </label>

          <div className={`flex items-start justify-center lg:justify-start lg:ml-28 mt-5 lg:mt-10 transition-all delay-[8s] duration-[2s] ease-out ${isVisibleMainMessage ? "opacity-100" : "opacity-0"} `}>
            <Auth0RegisterUserButton redirectUri='/portfolios/detail' />
          </div>

        </div>

      </div>
    </div>
  );
}

export default HomePage;
